import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { Routes, Route, useLocation } from 'react-router-dom';

import Header from './components/layout/Header';
import Footer from './components/layout/Footer';

import HeroSection from './components/sections/HeroSection';
import ServicesSection from './components/sections/ServicesSection';
import AboutSection from './components/sections/AboutSection';
import BookingStepsSection from './components/sections/BookingStepsSection';
import PopularServicesSection from './components/sections/PopularServicesSection';
import PackagesSection from './components/sections/PackagesSection';
import TestimonialsSection from './components/sections/TestimonialsSection';
import ContactSection from './components/sections/ContactSection';
import ServicesCarousel from './components/sections/ServicesCarousel';
import About from './components/sections/About';
import AboutUsPage from './components/AboutUsPage/AboutUsPage';
import BookingProcess from './components/sections/BookingProcess';
import ContactUs from './components/sections/ContactUs';
import CTA from './components/sections/CTA';
import ContactUsPage from './components/ContactUsPage/ContactUsPage';
import WaterDamageLanding from './components/LeadLandingPage/WaterDamageLanding';


const App = () => {
  const { pathname } = useLocation();

 
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, [pathname]);

  return (
    <Box  sx={{
    position: 'sticky',
    top: 0,
    zIndex: 1100,
    backgroundColor: 'background.default',
  }}>
    
      <Header />

      <Box
        component="main"
        sx={{
          pt: { xs: 8, md: 10 }, // offset for sticky header height
        }}
      >
        <Routes>
          {/* HOME PAGE */}
          <Route
            path="/"
            element={
              <>
                <HeroSection />
                <ServicesCarousel />
                <AboutSection />
                <BookingProcess />
                <ContactUs />
                <ServicesSection />
                <BookingStepsSection />
                <PopularServicesSection />
                <TestimonialsSection />
                {/* <PackagesSection /> */}
                <CTA />
                <ContactSection />
              </>
            }
          />

          {/* ABOUT PAGE */}
          <Route path="/about" element={<AboutUsPage />} />

          {/* SERVICES PAGE */}
          <Route path="/services" element={<ServicesSection />} />
          <Route path="/contact" element={<ContactUsPage />} />
          <Route path="/water-damage-help" element={<WaterDamageLanding/>} />
        </Routes>
      </Box>

      <Footer />
    </Box>
  );
};

export default App;
